
  		$('.navbar-toggler').click(function(){
          	$(this).collapse('toggle');
  		
  		})	
  
	  $('.navbar-toggler').on('show.bs.collapse', function () {
           $('#main-header').addClass('nav-mobile-m');
  		   $('.navbar-toggler-orange i').removeClass('fa-bars');
  		   $('.navbar-toggler-orange i').addClass('fa-plus');
  
        	$('.nav-mobile-m li.have-sub > a').off();

  			$('.nav-mobile-m li.have-sub > a').click(function(e){
              	 e.preventDefault();
  				 $(this).parent('li').toggleClass('active');
  			});

      })
  
  	  $('.navbar-toggler').on('hide.bs.collapse', function () {
          $('#main-header').removeClass('nav-mobile-m');
  		  $('.navbar-toggler-orange i').addClass('fa-bars');
  		  $('.navbar-toggler-orange i').removeClass('fa-plus');
  
      })
  
  
  
  
		
		 
  		var afterScrollHeight = $('#main-header > nav').height();
  
  	  $(window).scroll(function() {    
        var scroll = $(window).scrollTop();

        if (scroll >= (afterScrollHeight / 2)) {
            $("#main-header").addClass("scroll_fix");
        } else {
            $("#main-header").removeClass("scroll_fix");
        }
    });
  
  


// cart modal
$( ".add-to-cart, a[href$='pre-order']" ).click(function(e) {
  e.preventDefault();
  
  openDrawer();
});

$(document).ready(function() {
  if (window.location.href.indexOf("cart_modal_open=true") > -1) {
    openDrawer();
  }

  CartJS.clear();
});

$( "#cart-modal .cart-details .quantity .custom-select" ).change(function() {
  var quantity = $(this).val();
  
  updatePrice(quantity);
  updateComparePrice(quantity);
});

$(window).on("beforeunload", function() { 
  $( "#cart-modal .cart-details .quantity .custom-select" ).val(1);
});

$( "#preorder-btn" ).click(function(e) {
  e.preventDefault();
  
  var productHandle = "elliq";
  
  $.ajax({
      url: "/products/" + productHandle + ".js",
      method: 'GET',
      success: function(res) {
        var json = JSON.parse(res);
        var id = json.variants[0].id;
        var quantity = $("#cart-modal .cart-details .quantity .custom-select option:selected").text().substring(1);
        
      	$.ajax({
            url: "/cart/add.js",
            method: 'POST',
          	data:{
              quantity: quantity, 
              id: id
            },
            success: function(res) {
              window.location.replace("/checkout");
            }
        });
      }
  });
});


// homepage video modals
$( "a[href$='video']" ).click(function(e) {
  e.preventDefault();
  
   var videoSrc = $(this).data("video-src");
   var video = videojs("modal-video");
  video.ready(function () {
    $(".video-overlay").fadeIn("slow");
    $("body").css("overflow-y", "hidden");
  })
    video.src({ type: 'video/youtube', src: videoSrc });

//   //Create the element using the createElement method.
//   var myDiv = document.createElement("div");

//   //Set its unique ID.
//   myDiv.id = 'youtube-video';

//   //Add your content to the DIV
//   myDiv.innerHTML = `<div class='video-overlay' style='display: none'>` +
//   `<div class='text-right'><a id='close-video' href='#'>x</a></div>`+
//       `<div class='video-wrapper'>` +
//         `<video id='modal-video' class='video-js vjs-default-skin vjs-big-play-centered' controls autoplay` +
//     	`data-setup='{ "techOrder": ["youtube"], "sources": [{ "type": "video/youtube", "src": ${videoSrc}}] }'` +
//         `></video>` +
//       `</div>` +
//     `</div>`;
  
//   //Finally, append the element to the HTML body
//   document.body.appendChild(myDiv);
//   var video = videojs('modal-video');
//   video.src({ type: 'video/youtube', src: videoSrc });


});

$( "body .video-overlay #close-video" ).click(function(e) {
  e.preventDefault();
  
  var video = videojs('modal-video');
  video.pause();
  
  $(".video-overlay").fadeOut("slow");
  $("body").css("overflow-y", "visible");
  document.getElementById("youtube-video").style.display = "none";
});


// features page
if($("#features").length > 0) {
  $("#features .text-with-image a.text-block").hover(function(e) {
    e.preventDefault();

    var imgUrl = $(this).data("src");
    $("#features .text-with-image #features-banner-img").attr("src", imgUrl);
    $("#features .text-with-image a.text-block").removeClass("active");
    $(this).addClass("active");
  });
  
  $("#features .text-with-image a.text-block").click(function(e) {
    e.preventDefault();
  });

  var featuresCarousel = new Siema({
    selector: '#features-app-carousel',
    duration: 200,
    easing: 'ease-out',
    perPage: 1,
    startIndex: 0,
    draggable: true,
    multipleDrag: true,
    threshold: 20,
    loop: false,
    rtl: false,
    onChange: onSlideChange
  });

  $(".carousel-pagination .dot-nav").click(function(e) {
    e.preventDefault();

    var index = $(this).data('index');
    featuresCarousel.goTo(index);
    $(".carousel-pagination .dot-nav").removeClass("active");
    $(this).addClass("active");
  });


  function onSlideChange() {
    var currentSlide = this.currentSlide;
    $(".carousel-pagination .dot-nav").removeClass("active");
    $(".carousel-pagination .dot-nav[data-index=" + currentSlide + "]").addClass("active");
  }
}

// press page 
$( document ).ready(function() {
    applySameHeightToPressImages();
});

 
function applySameHeightToPressImages() {
  if($("#press").length > 0) {
    var maxHeight = -1;
  
//     $("#press .in-press .press-block .press-img-wrapper").each(function() {
//         var h = $(this).height(); 
//         maxHeight = h > maxHeight ? h : maxHeight;
//     });
    
//     $("#press .in-press .press-block .press-img-wrapper").css("height", maxHeight);
  }
}




// anchor page template
$( ".anchor-links a" ).click(function(event) {
  event.preventDefault();
  var val = $(this).attr("href");
  scrollToAnchor(val);
});



// subscribe modal
$(document).ready(function(){
  $(document).on("click",".closeBtn",function(){
    $(this).closest(".subscriberPopupModule").removeClass("active");
  })
})


function setCookie(cookieName, cookieValue, nDays) {
    var today = new Date();
    var expire = new Date();
    if (nDays == null || nDays == 0)
        nDays = 1;
    expire.setTime(today.getTime() + 3600000 * 24 * nDays);
    document.cookie = cookieName + "=" + escape(cookieValue)
            + ";expires=" + expire.toGMTString()
            + ";path=/";

}
function getCookie(c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
}



$(window).on("load",function(){
 // $(".subsriberWrapper.style1 form input[type='email']").attr("placeholder", "enter your email here");
 // $(".subsriberWrapper.style2 form input[type='email']").attr("placeholder", "email");
  if(sessionStorage.getItem('modalSubscribe') != 'live' && getCookie('modalSub') != 'true'){
    setTimeout(function(){ $(".subscriberPopupModule").addClass("active"); }, 5000);
    sessionStorage.setItem('modalSubscribe', 'live');
  }


  // lazy loading
    var lazyLoadInstance = new LazyLoad({
       elements_selector: ".lazy"
    });
  
}) 







function openDrawer() {
  $.ajax({
    url: "/cart/clear.js",
    method: 'POST',
    success: function(res) {
      buildDrawer();
    }
  });
}

function buildDrawer() {
  getProduct();
}

function getProduct() {
  var productHandle = "elliq";
  
  $.ajax({
      url: "/products/" + productHandle + ".js",
      method: 'GET',
      success: function(res) {
      	var json = JSON.parse(res);
        buildCartProduct(json);
      }
  });
}

function buildCartProduct(json) {
  var title = "Your sidekick will be on its way soon";
  var image = json.featured_image;
  var description = json.description;
  var price = Shopify.formatMoney(json.price);
  var compareAtPrice = Shopify.formatMoney(json.compare_at_price).replace(".00", "");
  
  $("#cart-modal #ModalTitle").html(title);
  $("#cart-modal #featuredImage").attr("src", image);
  $("#cart-modal #description").html(description);
  $("#cart-modal .price").html(price);
  $("#cart-modal .price").data('item-price', price);
  $("#cart-modal .initialPrice .comparePrice").html(compareAtPrice);
  $("#cart-modal .initialPrice .comparePrice").data('compare-price', compareAtPrice);

  
  
  showModal();
}

function showModal() {
  $("#preordernow").modal({
    show: true
  });
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function updatePrice(quantity) {
  var priceElement = $("#cart-modal .cart-details .prices .price");
  var price = parseInt(priceElement.data('item-price').replace('$','').replace(/,/g, ""), 10);
  var totalPrice = "$" + numberWithCommas(quantity * price) + ".00";
  
  priceElement.html(totalPrice);
}

function updateComparePrice(quantity) {
  var priceElement = $("#cart-modal .cart-details .prices .initialPrice .comparePrice");
  var price = parseInt(priceElement.data('compare-price').replace('$',''), 10);
  var totalPrice = "$" + (quantity * price);
  
  priceElement.html(totalPrice);
}

function scrollToAnchor(val){
  var screenWidth = $(window).width();
  var offset = 180;
  
  if(screenWidth < 576) {
    offset = 220;
  }
  
  $('html,body').animate({scrollTop: $(val).offset().top - offset},'slow');
}
